export { default } from './DetailedCarNew';
